module.exports = require('../_components/@alicd/next-radio/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/radio/index.js
// module id = 149
// module chunks = 0